'use client';

/**
 * fetch wrapper that logs every request/response to the browser console.
 * Drop-in replacement for fetch() in client components.
 *
 * Usage:
 *   import { apiFetch } from '@/lib/apiLogger';
 *   const data = await apiFetch('/api/get-in-touch', { method: 'POST', body: JSON.stringify(payload) });
 */
export async function apiFetch(url, options = {}) {
  const method = (options.method ?? 'GET').toUpperCase();
  const start  = Date.now();

  console.log(`%c[API] → ${method} ${url}`, 'color:#6366f1;font-weight:bold');

  if (options.body) {
    try {
      console.log('%c[API]   body:', 'color:#888', JSON.parse(options.body));
    } catch {
      console.log('%c[API]   body:', 'color:#888', options.body);
    }
  }

  try {
    const res  = await fetch(url, options);
    const ms   = Date.now() - start;
    const ok   = res.ok;
    const style = ok ? 'color:#22c55e;font-weight:bold' : 'color:#ef4444;font-weight:bold';
    const icon  = ok ? '✓' : '✗';

    // Clone to read body without consuming the stream
    const clone = res.clone();
    let json;
    try { json = await clone.json(); } catch { json = null; }

    console.log(`%c[API] ${icon} ${method} ${url} → ${res.status} (${ms}ms)`, style);
    if (json !== null) console.log('%c[API]   response:', 'color:#888', json);

    // Return the original response so the caller can still use .json()
    return res;
  } catch (err) {
    const ms = Date.now() - start;
    console.error(`[API] ✗ ${method} ${url} → NETWORK ERROR (${ms}ms)`, err);
    throw err;
  }
}
